import { Fragment } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

function ContentBackground(props) {
  const { theme, className, ...otherProps } = props;

  return (
    <Fragment>
      <style jsx>{`
        .content-background
          background-color ${theme.colors.content}
          color ${theme.colors.primary}
      `}
      </style>
      <div
        className={cx('content-background', className)}
        {...otherProps}
      />
    </Fragment>
  );
}

ContentBackground.propTypes = {
  /** @ignore */
  theme: themePropTypes(`{
    colors: {
      content,
    },
  }`),
  className: PropTypes.string,
};

const ContentBackgroundWithHOCs = withTheme(ContentBackground);
ContentBackgroundWithHOCs.displayName = 'ContentBackground';

export { ContentBackground as StorybookComponent };
export default ContentBackgroundWithHOCs;
